import * as yup from 'yup';
import {
  getEmailSchema,
  getPasswordSchema,
} from '@xarvio/frontend-core-platform/lib/validation/authSchemas';

export const getLoginSchema = () => {
  return yup.object().shape({
    email: getEmailSchema(),
    password: getPasswordSchema(),
  });
};
